import { render } from "./FullReportTableCallerNumbers.vue?vue&type=template&id=5046cae3"
import script from "./FullReportTableCallerNumbers.vue?vue&type=script&lang=js"
export * from "./FullReportTableCallerNumbers.vue?vue&type=script&lang=js"
script.render = render

export default script